import axios from 'axios';
import { deleteMethodWithToken } from 'utils/services/apiService';
import url from 'utils/services/urls.json';

// Action Types
export const DELETE_DOCTOR = 'DELETE_DOCTOR';
export const DELETE_DOCTOR_SUCCESS = 'DELETE_DOCTOR_SUCCESS';
export const DELETE_DOCTOR_FAILURE = 'DELETE_DOCTOR_FAILURE';

// Action Creators
export const deleteDoctor = () => ({
  type: DELETE_DOCTOR,
});

export const deleteDoctorSuccess = (users) => ({
  type: DELETE_DOCTOR_SUCCESS,
  payload: users,
});

export const deleteDoctorFailure = (error) => ({
  type: DELETE_DOCTOR_FAILURE,
  payload: error,
});

// Thunk Function
export const deleteDoctorData = (external, role) => {
  return async (dispatch) => {
    dispatch(deleteDoctor());
    try {
      let deleteUrl = url?.doctorDelete;
      if (role === 'doctor') {
        deleteUrl = url?.doctorDelete + '?doctor=1';
      } else if (role === 'patient') {
        deleteUrl = url?.doctorDelete + '?patient=1';
      } else if (role === 'both') {
        deleteUrl = url?.doctorDelete + '?patient=1&doctor=1';
      }

      const response = await deleteMethodWithToken(deleteUrl);
      if (response?.status === 200 || response?.status === 201) {
        dispatch(deleteDoctorSuccess(response?.data));
        if (external?.run === true) {
          external?.handleFunction(response?.data);
        }
      } else if (response?.status === 401 || response?.status === 403) {
        if (external?.authorize === true) {
          external?.handleAuthorizeFunction(response?.data);
        }
      } else {
        external?.handleErrorFunction(response?.data);
        dispatch(deleteDoctorFailure('error?.message'));
      }
    } catch (error) {
      dispatch(deleteDoctorFailure(error?.message));
    }
  };
};
